<template>
  <div class="promotion">
    <div
      class="top"
      :class="{
        localization: (type == 'localization'),
        hashtag: (type == 'hashtag'),
        followers: (type == 'followers')
      }"
    >
      <div class="label">
        <div v-if="type === 0" class="hashtag-icon">#</div>
        <div v-else-if="type === 1" class="followers-icon">@</div>
        <GlobeIcon v-else-if="type === 2" />
        <div class="name" :class="{ localization: (type == 'localization') }">{{ name }}</div>
      </div>
      <div class="icons-wrapper">
        <DeleteIcon class="delete-icon" @click.native="deletePromotion" />
        <div v-if="settings" @click="settings = !settings" class="settings">
          <SlidersIcon />
        </div>
        <div v-else @click="settings = !settings" class="settings">
          <InfoIcon />
        </div>
      </div>
    </div>

    <div class="stats">
      <ul>
        <PromotionStat
          v-for="stat in stats"
          :key="stat.id"
          :id="stat.id"
          :name="stat.name"
          :promotionId="id"
          :settings="settings"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import SlidersIcon from '@/components/svgs/icons/SlidersIcon.vue';
import InfoIcon from '@/components/svgs/icons/InfoIcon.vue';
import GlobeIcon from '@/components/svgs/icons/GlobeIcon.vue';
import PromotionStat from '@/components/promotions/PromotionStat.vue';
import DeleteIcon from '@/components/svgs/icons/DeleteIcon.vue';

export default {
  name: "Promotion",
  components: {
    DeleteIcon,
    GlobeIcon,
    InfoIcon,
    PromotionStat,
    SlidersIcon
  },
  props: ["id", "name", "type", "stats"],
  data() {
    return {
      settings: true
    };
  },
  methods: {
    deletePromotion() {
      const payload = {
        id: this.id,
        name: this.name,
        type: this.type
      };

      this.$store.commit('setPromotionToRemove', payload);
      this.showModal("DeletePromotionModal");
    },
    showModal(modal) {
      this.$store.commit('showModal', modal);
    }
  },
  filters: {
    shorten(value) {
      if (!value) return "";
      const stringValue = value.toString();
      if (stringValue.length > 12) return `${stringValue.slice(0, 12)}...`;
      return stringValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.promotion {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  overflow: hidden;

  .delete-icon {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s, visibility 0.25s;
  }

  &:hover {
    .delete-icon {
      opacity: 1;
      visibility: visible;
    }
  }
}

.top {
  min-height: 40px;
  border-bottom: 2px solid #707070;
  background-color: #222;
  border-radius: 10px 10px 0 0;
  cursor: default;
  display: flex;
  justify-content: space-between;

  .label {
    display: flex;
    align-items: center;
    padding: 10px;
    font-weight: bold;
  }

  .name {
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
  }

  .settings {
    height: 100%;
    font-size: 20px;
    text-align: right;
    padding: 10px 0 0 0;
    margin-right: 5px;
    .settings-icon {
      cursor: pointer;
      color: #707070;
      transition: color 0.25s ease;
      &:hover {
        color: #fff;
      }
    }
  }
}

.icons-wrapper {
  display: flex;
  align-items: center;
}

.localization-icon,
.followers-icon,
.hashtag-icon {
  margin-right: 5px;
  color: #707070;
}

ul {
  list-style: none;
  margin: 3px 0 0 0;
  padding: 2px 0;
  li {
    color: #707070;
    height: 40px;
    border-top: 1px solid #707070;
    padding: 10px 10px;
    display: flex;
    justify-content: space-between;
    margin: 0;
    .func {
      align-self: flex-end;
      width: 100px;
    }
    &:first-child {
      border: none;
    }
    .stat {
      float: right;
    }
    .value {
      float: right;
    }
    .check {
      float: right;
    }
  }
}

.info {
  height: 35px;
  padding: 8px;
  margin: 0;
  color: #bbb;
  font-weight: bold;
  background-color: #222;
  position: relative;
}

svg {
  height: 20px;
  fill: #707070;
  transition: fill 0.25s;
  margin: 0 5px;

  &:hover {
    fill: #fff;
    cursor: pointer;
  }
}

.label svg {
  margin-left: 0;
  margin-right: 5px;
}
</style>
